import { render, staticRenderFns } from "./StatClients.vue?vue&type=template&id=901b559e&"
import script from "./StatClients.vue?vue&type=script&lang=js&"
export * from "./StatClients.vue?vue&type=script&lang=js&"
import style0 from "./StatClients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports